import { EmailIcon, BagIcon, BellIcon } from "../../../../ui/Icon";
export const icons = { email: EmailIcon, bag: BagIcon, bell: BellIcon };
//# sourceMappingURL=types.js.map